module.exports = __webpack_public_path__ + "static/img/nav1.1c8b3226.svg";